var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("vs-icon", {
        directives: [
          {
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: "Editar repositorio",
            expression: "'Editar repositorio'",
            modifiers: { hover: true, bottom: true }
          }
        ],
        staticClass: "ml-4 mt-2",
        attrs: { bg: "lightgray", icon: "tune" },
        on: { click: _vm.openModal }
      }),
      _c(
        "b-modal",
        {
          ref: "editRepository",
          attrs: {
            title: "Editar repositorio",
            "hide-footer": "",
            centered: "",
            size: "lg",
            "no-close-on-backdrop": "",
            "hide-header-close": _vm.loading
          }
        },
        [
          _c(
            "form",
            {
              attrs: {
                "data-vv-scope": "repository-form",
                autocomplete: "off"
              },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.editRepository($event)
                }
              }
            },
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("vs-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|max:255",
                          expression: "'required|max:255'"
                        }
                      ],
                      staticClass: "w-100",
                      attrs: {
                        autocomplete: "off",
                        name: "name",
                        label: "Nombre para repositorio",
                        disabled: _vm.reset,
                        "data-vv-as": "nombre",
                        "val-icon-danger": "error_outline",
                        danger: _vm.errors.has("repository-form.name"),
                        "danger-text": _vm.errors.first("repository-form.name"),
                        "val-icon-success": "check_circle",
                        success:
                          !_vm.errors.has("repository-form.name") &&
                          _vm.name.length > 0
                      },
                      model: {
                        value: _vm.name,
                        callback: function($$v) {
                          _vm.name = $$v
                        },
                        expression: "name"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12 mt-3" },
                  [
                    _c("vs-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "max:255",
                          expression: "'max:255'"
                        }
                      ],
                      staticClass: "w-100",
                      attrs: {
                        autocomplete: "off",
                        name: "description",
                        label: "Descripción",
                        disabled: _vm.reset,
                        "data-vv-as": "descripción",
                        "val-icon-danger": "error_outline",
                        danger: _vm.errors.has("repository-form.description"),
                        "danger-text": _vm.errors.first(
                          "repository-form.description"
                        ),
                        "val-icon-success": "check_circle",
                        success:
                          !_vm.errors.has("repository-form.description") &&
                          _vm.description.length > 0
                      },
                      model: {
                        value: _vm.description,
                        callback: function($$v) {
                          _vm.description = $$v
                        },
                        expression: "description"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { staticClass: "col-12 mt-3" },
                [
                  _c(
                    "vs-checkbox",
                    {
                      staticClass: "ml-0",
                      model: {
                        value: _vm.reset,
                        callback: function($$v) {
                          _vm.reset = $$v
                        },
                        expression: "reset"
                      }
                    },
                    [_vm._v(" Reestablecer los nombres originales ")]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "m-top-20 d-flex justify-end" },
                [
                  _c(
                    "vs-button",
                    {
                      staticClass: "mt-5 ml-3",
                      attrs: {
                        color: "primary",
                        type: "border",
                        disabled: _vm.loading
                      },
                      on: { click: _vm.editRepository }
                    },
                    [
                      _vm._v(" Editar "),
                      _c("span", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.loading,
                            expression: "loading"
                          }
                        ],
                        staticClass:
                          "spinner-border spinner-border-sm text-white"
                      })
                    ]
                  )
                ],
                1
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }